import { useMutation } from "@tanstack/react-query";
import { api } from "../../../api";
import { ProvisionOrgBody, OrgCategory } from "../../../generated/core-api";
import { useOrgMutationSuccess } from "./useOrgMutationSuccess";

/**
 * Hook for provisioning a new organization
 */
export function useProvisionOrg() {
  const onSuccess = useOrgMutationSuccess(OrgCategory.public);

  return useMutation({
    mutationFn: async (orgData: ProvisionOrgBody) => {
      return await api.provisionOrg(orgData);
    },
    onSuccess,
  });
}
